module.exports = __webpack_public_path__ + "media/images/like-empty-54e8b120419686e1379880dbcb4c99f6.png";